import React from 'react';

import { StageTable } from 'app/modules/Betting';

import styles from './StageGrid.module.scss';

export const StageGrid = () => {
  return (
    <div className={styles.content}
         data-test="content-container">
      <StageTable />
    </div>
  );
};
